import type { ApprovalResult, Receiver, ReceiverId, ReceiverRequest } from '../generated-types';
import { CONTEXT_PATH } from './index';
import { del, get, post, put } from './request';

export const RECEIVER_SERVICE_PATH = 'rest/resource/receivers';

export async function getReceivers(): Promise<Receiver[]> {
    return get<Receiver[]>(`${CONTEXT_PATH}/${RECEIVER_SERVICE_PATH}`);
}

export async function createReceiver(receiver: ReceiverRequest): Promise<Receiver> {
    return post<Receiver>(`${CONTEXT_PATH}/${RECEIVER_SERVICE_PATH}`, receiver);
}

export async function updateReceiver(receiverId: ReceiverId, receiver: ReceiverRequest): Promise<ApprovalResult> {
    return put<ApprovalResult>(`${CONTEXT_PATH}/${RECEIVER_SERVICE_PATH}/${receiverId.value}`, receiver);
}

export async function deleteReceiver(receiverId: ReceiverId): Promise<Receiver> {
    return del<Receiver>(`${CONTEXT_PATH}/${RECEIVER_SERVICE_PATH}/${receiverId.value}`);
}
